import { INotActiveProps } from "interfaces";
import NotActiveVideoIcon from "../../icon-components/notActiveVideoIcon";

const NotActive = ({ title, description, type }: INotActiveProps) => {
    return (
        <div className={`pl-w-full pl-h-full pl-rounded-2xl pl-flex pl-flex-col pl-gap-4 pl-justify-center pl-items-center`}>
            <div className="pl-flex pl-justify-center">
                <NotActiveVideoIcon />
            </div>
            {title ? (
                <h1 id="notActive" className="pl-text-center pl-text-secondary-800 pl-text-[16px] pl-font-bold">
                    {title}
                </h1>
            ) : null}
            <p className="pl-text-[14px] pl-text-secondary-600 pl-font-normal pl-text-center pl-leading-6">{description}</p>
            {type === "404" && (
                <a
                    href=""
                    className="pl-bg-main hover:pl-bg-main-700 pl-transition-colors pl-duration-300 pl-text-white pl-w-[280px] pl-py-4 pl-rounded-[8px] pl-font-medium pl-text-[15px] pl-text-center"
                >
                    تلاش مجدد
                </a>
            )}
        </div>
    );
};

export default NotActive;
